import React from 'react';
import { ButtonProps, Button } from '@mui/material';
import { useFormSubmit } from '@travelity/form';

export const SubmitButton: React.FC<ButtonProps> = props => {
    const submit = useFormSubmit();

    return <Button {...props} onClick={submit} />;
};
